
<div class="pdf-area">
    <!-- <iframe
    type="application/pdf"
    [src]="fileUrl"
    (load)="onDocumentLoad()"
    (error)="onFileError()"
    ></iframe> -->


    <dk-doc-viewer-manager
    [url]="fileUrl"
    [documentLoad]="documentLoad"
    [docId]="docId"

  ></dk-doc-viewer-manager> 
</div>